import { Box, Card,Text,useColorModeValue, CardBody, CardHeader, Heading, CardFooter,Link } from "@chakra-ui/react"

export const About = ()=>{

  return (
    <Card borderWidth="1px"
    borderRadius="lg"
    w={{ sm: '100%', md: '750px', lg:"70%" }}
    bg={useColorModeValue('white','gray.900')}
    boxShadow={'2xl'}
    padding={4} m="auto" variant={"elivated"} >

  <CardBody>
      <Box>
        <Heading size='lg' color={"blue.500"} >
          I'm Ganesh Kumar
        </Heading>
        <Text px={["3"]} p={["","5","5","10"]} color={useColorModeValue("black","white")} fontSize={["sm","sm",'lg']}>
        To obtain a challenging Tech Support Engineer role that
allows me to utilize my technical skills and passion for
problem-solving to assist customers with their technical issues
and contribute to the growth of the organization. As a highly
motivated and detail-oriented individual, I am committed to
providing excellent customer service and continuously
learning and improving my technical expertise.

        </Text>
      </Box>
  </CardBody>
  <CardFooter mt={"-40px"} mb="30px" justifyContent={"center"} >
     <Link color='blue.500' href="mailto:kganesh011995@gmail.com" target={"blank"} ><Text color={"blue.400"} textDecorationColor={"blue.400"} >kganesh011995@gmail.com</Text></Link>
  </CardFooter>
</Card>
  )
}